import priorityPlus from 'priority-plus'

const navigation = {
  el: {
    headerNavigation: document.querySelector<HTMLElement>('.header__navigation .header-navigation__list'),
    mobileNavigation: {
      closeTrigger: document.querySelector<HTMLElement>('.mobile-navigation__close-button'),
      menuContainer: document.querySelector<HTMLElement>('.mobile-navigation__menu'),
      menuHeader: document.querySelector<HTMLElement>('.mobile-navigation__header'),
      menuChevrons: document.querySelectorAll<HTMLElement>('.mobile-menu__chevron'),
      openTrigger: document.querySelector<HTMLElement>('.header__button--mobile-navigation'),
      root: document.querySelector<HTMLElement>('.mobile-navigation'),
    },
    subnavigation: document.querySelector<HTMLElement>('.subnavigation__list'),
    // mypagesNavigation: document.querySelector<HTMLElement>('.mypageNav__navigation-list'),
  },

  init(): void {
    this.initPPlusNavigation()
    this.initMobileNavigation()
  },

  initMobileNavigation(): void {
    this.el.mobileNavigation.openTrigger.addEventListener('click', () => {
      this.el.mobileNavigation.root.classList.add('mobile-navigation--active')
      this.selectCurrentNavigationLink()
    })

    this.el.mobileNavigation.closeTrigger.addEventListener('click', () => {
      this.el.mobileNavigation.root.classList.remove('mobile-navigation--active')
      this.resetMobileNavigation()
    })

    this.el.mobileNavigation.menuChevrons.forEach((chevron) => {
      chevron.addEventListener('click', () => {
        chevron.parentElement.classList.toggle('mobile-menu__item--active')
      })
    })
  },

  initPPlusNavigation(): void {
    if (this.el.headerNavigation) {
      priorityPlus(this.el.headerNavigation, {
        innerToggleTemplate: '...',
      })
    }

    if (this.el.subnavigation) {
      priorityPlus(this.el.subnavigation, {
        innerToggleTemplate: '...',
      })
    }
  },

  initPPlusNavigationMypages(mypagesNavigation: HTMLElement): void {
    if (mypagesNavigation) {
      priorityPlus(mypagesNavigation, {
        innerToggleTemplate: '...',
      })
    }
  },

  resetMobileNavigation(): void {
    this.el.mobileNavigation.root.querySelectorAll('.mobile-menu__item--active').forEach((item) => {
      item.classList.remove('mobile-menu__item--active')
    })
  },

  selectCurrentNavigationLink(): void {
    const currentLocation = window.location.pathname
    let locationsArray = []

    const createLocationsArray = (location) => {
      const segments = location.split('/').filter(Boolean)
      const segmentsArray = segments.map((_, index) => {
        return `/${segments.slice(0, index + 1).join('/')}/`
      })
      return segmentsArray
    }

    const click = (selector) => {
      const clickEvent = new MouseEvent('click', {
        view: window,
        bubbles: true,
        cancelable: true,
      })

      selector.dispatchEvent(clickEvent)
    }

    locationsArray = createLocationsArray(currentLocation)

    const currentLink = this.el.mobileNavigation.root.querySelector<HTMLElement>(`.mobile-menu__link[href='${currentLocation}']`)
    const headerHeight = this.el.mobileNavigation.menuHeader.getBoundingClientRect().height

    currentLink.classList.add('mobile-menu__link--current')

    locationsArray.forEach((location) => {
      const link = this.el.mobileNavigation.root.querySelector(`.mobile-menu__link[href='${location}']`)
      const chevron = link?.parentElement?.querySelector('.mobile-menu__chevron')
      const itemHasSubnavigation = link?.parentElement?.classList.contains('mobile-menu__item--has-subnavigation')

      if (chevron && itemHasSubnavigation) {
        click(chevron)
        this.el.mobileNavigation.menuContainer.scrollTo(0, currentLink.getBoundingClientRect().top - headerHeight - 40)
      }
    })
  },
}

export default navigation
